import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as reducer from './reducer'
import * as state from './state'
import * as R from 'ramda'
import { ExtraView } from './model'
import { categories } from './constants'
import { getItemCategoryOptions, selectRentalEntities, selectUserEntities } from '@tokeet-frontend/tv3-platform'

export const extraState = createFeatureSelector<state.State>('extra')

export const selectAllExtras = createSelector(extraState, reducer.selectAll)

export const selectExtrasLoaded = createSelector(extraState, (state: state.State) => state.isLoaded)

export const selectExtras = createSelector(
  selectAllExtras,
  selectRentalEntities,
  selectUserEntities,
  (extras, rentalEntities, usersById) => {
    return R.map((extra: ExtraView) => {
      const rental = rentalEntities[extra.rental_id]
      const user = usersById[extra.created_by]

      return {
        ...extra,
        rentalView: R.pathOr('', ['name'], rental),
        createdByView: `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
        rental,
      }
    }, extras) as ExtraView[]
  }
)

export const selectExtraById = (id: string) =>
  createSelector(selectAllExtras, (items) => {
    return items?.find((item) => item.pkey === id)
  })

export const selectAllExtraCategories = createSelector(selectAllExtras, (extras) => {
  return getItemCategoryOptions(extras, categories)
})

export const selectExtrasByInquiryId = (inquiryId: string) =>
  createSelector(selectExtras, (extras) => extras.filter((extra) => extra.inquiry_id === inquiryId))
